import type { Params } from '../../lib/types';
import { presets, applyPreset, matchPreset, type PresetId } from '../../lib/presets';

export function PresetsDropdown({ params, onLoad }: { params: Params; onLoad: (p: Params) => void }) {
  const active = matchPreset(params);
  return (
    <div className="flex items-center gap-2">
      <select
        value={active ?? ''}
        onChange={(e) => onLoad(applyPreset(e.target.value as PresetId, params))}
        className="rounded border border-[var(--border)] bg-[var(--entry)] px-2 py-1 text-sm"
      >
        <option value="">Custom</option>
        {presets.map((p) => (
          <option key={p.id} value={p.id}>{p.label}</option>
        ))}
      </select>
      {!active && <span className="text-xs text-[var(--secondary)]">Modified</span>}
    </div>
  );
}
